import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import noSelected from 'assets/images/noSelectedTransfer.svg'
import { batch, useDispatch } from 'react-redux'
import { fetchBusinessDate } from 'store/actions/configs'
import ContentBox from '@shared/ContentBox'
import { Col, Grid, Row, Typography } from 'antd'

function Main() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { xs } = Grid.useBreakpoint()

  useEffect(() => {
    batch(() => {
      dispatch(fetchBusinessDate())
    })
  }, [])

  return (
    <ContentBox hasContent={false} title={t('home.orders')}>
      <Row
        justify="center"
        align="middle"
        style={{ flexDirection: 'column', height: '80vh', gap: 24 }}
      >
        <Col>
          <Typography.Text style={xs ? { fontSize: 18 } : { fontSize: 24 }}>
            {t('newTransfer.noSelectedTransfer')}
          </Typography.Text>
        </Col>
        <Col>
          <img src={noSelected} style={xs ? { width: 300 } : {}} />
        </Col>
      </Row>
    </ContentBox>
  )
}

export default Main
